(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["case-zoom"] && !Shopify.designMode) return;
  try {
    /* One <dialog>, built on first use and reused, so a page with several
     workstreams still carries a single popup. showModal gives the focus trap,
     Escape and the backdrop natively. Skipped in the theme editor, where a
     click on a block has to select it rather than open a popup. */
  (function () {
    if (window.__caseLightboxBound) return;
    window.__caseLightboxBound = true;

    var dialog = null;
    var scroller = null;
    var image = null;
    var returnFocus = null;
    var SVG_NS = 'http://www.w3.org/2000/svg';

    function closeIcon() {
      var svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      ['M18 6 6 18', 'M6 6l12 12'].forEach(function (d) {
        var path = document.createElementNS(SVG_NS, 'path');
        path.setAttribute('d', d);
        svg.appendChild(path);
      });
      return svg;
    }

    /* A new <img> per open, not one reused element: Chrome keeps painting the
       previous image while a new src loads, so a reused element briefly takes the
       last capture's aspect ratio and the fit-content dialog opens at the wrong
       height, then jumps. A fresh element has nothing stale to borrow. */
    function freshImage() {
      var img = document.createElement('img');
      img.className = 'case-lightbox__img';
      img.decoding = 'async';
      return img;
    }

    function build() {
      dialog = document.createElement('dialog');
      dialog.className = 'case-lightbox';

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'case-lightbox__close';
      close.setAttribute('aria-label', 'Close');
      close.appendChild(closeIcon());
      close.addEventListener('click', function () { dialog.close(); });

      scroller = document.createElement('div');
      scroller.className = 'case-lightbox__scroll';
      image = freshImage();
      scroller.appendChild(image);

      dialog.appendChild(close);
      dialog.appendChild(scroller);
      document.body.appendChild(dialog);

      /* A click that lands on the dialog element itself is the backdrop. */
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
        image.removeAttribute('src');
        if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
      });
    }

    /* Shopify CDN URLs take a width parameter: ask for what the popup will
       actually show, at up to 2x density, instead of always the 2400 master.
       Theme asset URLs carry no such parameter and pass through unchanged. */
    function sizedSrc(url, cssWidth) {
      if (!/[?&]width=\d+/.test(url)) return url;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var want = Math.min(2400, Math.ceil((cssWidth * dpr) / 200) * 200);
      return url.replace(/([?&])width=\d+/, '$1width=' + want);
    }

    function open(frame) {
      var src = frame.getAttribute('data-case-zoom');
      if (!src) return;
      if (!dialog) build();

      var isEmail = frame.getAttribute('data-case-zoom-kind') === 'email';
      dialog.classList.toggle('case-lightbox--email', isEmail);
      dialog.setAttribute('aria-label', isEmail ? 'Full email' : 'Full screenshot');

      var frameImg = frame.querySelector('img');
      var next = freshImage();
      next.alt = frameImg ? frameImg.alt : '';

      /* The dialog sizes to its image, so without dimensions it would open at
         zero height and jump when the file arrives. The frame image's natural
         size wins once it has loaded: the theme-asset fallbacks write one fixed
         width and height for every file, and the Make Time Wellness emails run
         from 3.9 to 13.9 times taller than wide. Only the ratio matters here. */
      var w = 0;
      var h = 0;
      if (frameImg) {
        w = frameImg.naturalWidth || parseInt(frameImg.getAttribute('width'), 10) || 0;
        h = frameImg.naturalHeight || parseInt(frameImg.getAttribute('height'), 10) || 0;
      }
      if (w && h) {
        next.setAttribute('width', w);
        next.setAttribute('height', h);
      }

      scroller.replaceChild(next, image);
      image = next;
      scroller.scrollTop = 0;
      returnFocus = frame.querySelector('.case-zoom') || document.activeElement;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();

      /* Sized after showModal, from the width this kind of popup really renders
         at, so the CSS widths are not repeated as numbers in this script. */
      next.src = sizedSrc(src, scroller.clientWidth);
    }

    document.addEventListener('click', function (e) {
      if (window.Shopify && window.Shopify.designMode) return;
      var frame = e.target && e.target.closest ? e.target.closest('[data-case-zoom]') : null;
      if (!frame) return;
      e.preventDefault();
      open(frame);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section-background"] && !Shopify.designMode) return;
  try {
    // Shared background-video loader. Originally written inline in growth-section /
  // who-section; lifted here verbatim in behaviour so every section with a video
  // slot gets the same performance posture from one place. Guarded + idempotent:
  // shipping it from multiple renders is harmless.
  (function () {
    if (window.UMGBgVideo) {
      window.UMGBgVideo.init();
      return;
    }

    function initBgVideo(root) {
      var wraps = (root || document).querySelectorAll('[data-bg-video]');

      wraps.forEach(function (wrap) {
        if (wrap.dataset.bgVideoBound === 'true') return;

        // Never spend bytes for users who won't see motion anyway.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { wrap.dataset.bgVideoBound = 'true'; return; }
        if (navigator.connection && navigator.connection.saveData) { wrap.dataset.bgVideoBound = 'true'; return; }
        // Hidden variant (other breakpoint): leave UNBOUND so the breakpoint
        // listener below can bind it if a resize/rotation makes it visible.
        if (getComputedStyle(wrap).display === 'none') return;

        wrap.dataset.bgVideoBound = 'true';

        var video = wrap.querySelector('video');
        if (!video) return;

        var loaded = false;

        function pickSource() {
          // Shopify transcodes the upload into multiple MP4 renditions; serve
          // the smallest one that still looks sharp instead of the 4K master.
          var cap = window.innerWidth <= 768 ? 720 : 1080;
          var sources = Array.prototype.slice
            .call(video.querySelectorAll('source[data-src]'))
            .map(function (s) {
              return { url: s.dataset.src, height: parseInt(s.dataset.height, 10) || 0 };
            })
            .sort(function (a, b) { return a.height - b.height; });

          if (!sources.length) return null;

          var best = null;
          sources.forEach(function (s) {
            if (s.height <= cap) best = s;
          });
          return best || sources[0];
        }

        // Rendition cap by viewport width, mirroring pickSource's MP4 logic.
        // 0 = no cap (let the ABR ladder run). Deliberately NOT element-size
        // based: a full-bleed phone section is ~880 CSS px TALL, and height x
        // DPR "justifies" the 1080p/7.2Mbps rung — 10.3MB of an 11.7MB page
        // for a decorative background. 480p is visually clean on phones.
        function hlsCapHeight() {
          // Every breakpoint locks ONE rung — no adaptive ladder anywhere.
          // Handing the player the master playlist made it open on a low
          // rung and ramp up over a few seconds, which reads as the video
          // "starting blurry then going HD" (Brady, 2026-08-06). Locking
          // starts sharp; the fade-in already hides the buffering beat.
          // 720p (4.5Mbps) phones/tablets, 1080p (7.2Mbps) desktop. Video
          // loads post-LCP, so this costs real-user bytes, not lab score.
          var w = window.innerWidth;
          if (w <= 1280) return 720;
          return 1080;
        }

        // Pick the best media playlist <= cap from an HLS master. min(w,h)
        // is the "p" number for both landscape and portrait renditions.
        function pickHlsVariant(text, baseUrl, cap) {
          var lines = text.split(/\r?\n/);
          var best = null;
          for (var i = 0; i < lines.length; i++) {
            if (lines[i].indexOf('#EXT-X-STREAM-INF') !== 0) continue;
            var m = lines[i].match(/RESOLUTION=(\d+)x(\d+)/);
            var h = m ? Math.min(parseInt(m[1], 10), parseInt(m[2], 10)) : 0;
            var uri = (lines[i + 1] || '').trim();
            if (!uri || uri.charAt(0) === '#') continue;
            if (h && h <= cap && (!best || h > best.h)) best = { h: h, uri: uri };
          }
          if (!best) return null;
          // baseUrl is protocol-relative (//cdn/...) — new URL() throws on
          // that as a base, so absolutize it against the page first.
          try {
            return new URL(best.uri, new URL(baseUrl, window.location.href)).href;
          } catch (e) { return null; }
        }

        function start(srcUrl) {
          video.src = srcUrl;
          video.load();
          video.addEventListener('playing', function () {
            wrap.classList.add('is-playing');
          }, { once: true });
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }

        function loadAndPlay() {
          if (loaded) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
            return;
          }
          loaded = true;
          // Native-HLS browsers (Safari/iPhone, and Chrome now ships native
          // HLS too) get the adaptive playlist — capped to the smallest
          // rendition the element can show. Master on any fetch/parse failure.
          var hls = video.dataset.hls;
          if (hls && video.canPlayType('application/vnd.apple.mpegurl')) {
            var cap = hlsCapHeight();
            if (cap && window.fetch) {
              fetch(hls)
                .then(function (r) { return r.ok ? r.text() : ''; })
                .then(function (t) { start(pickHlsVariant(t, hls, cap) || hls); })
                .catch(function () { start(hls); });
            } else {
              start(hls);
            }
          } else {
            var src = pickSource();
            if (!src) { loaded = false; return; }
            start(src.url);
          }
        }

        if (!('IntersectionObserver' in window)) {
          loadAndPlay();
          return;
        }

        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadAndPlay();
            } else if (loaded) {
              video.pause();
            }
          });
        }, { rootMargin: '400px 0px' });

        io.observe(wrap);
      });
    }

    window.UMGBgVideo = { init: initBgVideo };

    // Videos never compete with the initial render: an in-viewport section used
    // to start its (multi-MB) download immediately, saturating a phone
    // connection exactly while the hero LCP image loaded — Lighthouse measured
    // 8.2s mobile LCP from that contention alone. Binding only after the load
    // event plus an idle beat costs an imperceptible delay on an ambient
    // background loop (it fades in regardless) and frees the whole pipe for
    // critical resources.
    function whenSettled(cb) {
      var idle = window.requestIdleCallback || function (f) { setTimeout(f, 200); };
      if (document.readyState === 'complete') {
        idle(cb);
      } else {
        window.addEventListener('load', function () { idle(cb); }, { once: true });
      }
    }

    whenSettled(function () { initBgVideo(); });

    // Crossing the 700px layout breakpoint swaps which video variant is
    // visible; the hidden one was left unbound above, so re-scan and bind it.
    var bgBpMq = window.matchMedia('(max-width: 700px)');
    function onBgBp() { whenSettled(function () { initBgVideo(); }); }
    if (bgBpMq.addEventListener) bgBpMq.addEventListener('change', onBgBp);
    else if (bgBpMq.addListener) bgBpMq.addListener(onBgBp);

    // Theme editor: re-bind immediately when a section is re-rendered — the
    // merchant is waiting to see their video, and the page is long loaded.
    document.addEventListener('shopify:section:load', function (e) {
      initBgVideo(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
